import { UserModel } from "../Models/UserModel";

interface SessionStorageInterface {
    token: string;
    userId: string;
    expiration: Date;
}

export function getSession(sessionKey : string){
    const response = sessionStorage.getItem(sessionKey);
    return response;
}

export function setSession(sessionKey: string, sessionValue: string){
    sessionStorage.setItem(sessionKey, sessionValue);
}

const GetTokenSession = () => {
    return sessionStorage.getItem("token");
}

const GetInfosSession = () => {
    var token = sessionStorage.getItem("bearer-token") ?? "";
    var userId = sessionStorage.getItem("userId") ?? "";

    return {token: token, userId: userId};
}

const GetUserSession = () => {
    return sessionStorage.getItem("user") ?? "";
}

const GetTenantIdSession = () => {
    return sessionStorage.getItem("tenantId") ?? "";
}

const GetTimeoutSession = () => {
    return JSON.stringify(sessionStorage.getItem("timeout")) ?? "";
}

const GetRolesSession = () => {
    return sessionStorage.getItem("roles") ?? "";
}

const SetTokenSession = (value: string) => {
    sessionStorage.setItem("token", value);
}

const SetTimeoutSession = (value: string) => {
    sessionStorage.setItem("timeout", value);
    window.dispatchEvent(new Event("storage"));
}

const SetUserSession = (value: string) => {
    sessionStorage.setItem("user", JSON.stringify(value));
}

const SetRolesSession = (roles: string[]) => {
    sessionStorage.setItem("roles", JSON.stringify(roles));
}

const ClearSession = () => {
    sessionStorage.clear();
}

const SetTenantIdSession = (tenantId: string) => {
    sessionStorage.setItem("tenantId", tenantId);
}

export {
    GetTokenSession,
    GetInfosSession,
    GetUserSession,
    GetRolesSession,
    GetTimeoutSession,
    GetTenantIdSession,
    SetTokenSession,
    SetUserSession,
    SetRolesSession,
    SetTimeoutSession,
    SetTenantIdSession,
    ClearSession
}